<script>
import router from "../../router";
export default {
  name: "AddTax",

  data() {
    return {
      stores: [],
      selectedStores: [],
      tax: {
        name: "",
        type: "",
        option: ""
      },
      isAll: false,
      availableStoreStr: ""
    };
  },
  methods: {
    checkAllStores(event) {
      this.selectedStores = [];
      this.availableStoreStr = "";

      if (this.isAll) {
        for (var i = 0; i < this.stores.length; i++) {
          this.selectedStores.push(this.stores[i].id);
        }
      }
      this.setAvailableStr();
    },

    setAvailableStr() {
      this.availableStoreStr = "";
      if (this.selectedStores.length > 0) {
        if (this.selectedStores.length == this.stores.length) {
          this.isAll = true;
          this.availableStoreStr = this.$lang.messages.available_in_all_stores;
        } else {
          this.isAll = false;
          if (this.selectedStores.length == 1) {
            this.availableStoreStr =
              this.$lang.messages.available_in +
              " 1 " +
              this.$lang.messages.store_lowercase;
          } else {
            this.availableStoreStr =
              this.$lang.messages.available_in + " "+
              this.selectedStores.length +
              " " +
              this.$lang.messages.store_lowercase;
          }
        }
      }
    },
    checkUncheckStore(event) {
      this.setAvailableStr();
      if (event && !event.target.checked) {
        this.isAll = false;
      }
    },
    getStores() {
      this.stores = [];
      this.$api
        .getAPI({
          _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}`
        })
        .then(res => {
          this.stores = res.list;

          if (!this.tax.id) {
            this.isAll = true;
            this.checkAllStores();
          } else {
            this.details(this.tax.id);
          }
        });
    },
    details(id) {
      this.tax = {};

      this.$api
        .getAPI({
          _action: "/tax/detail/" + id
        })
        .then(res => {
          this.tax = res;

          if (res.stores && res.stores.length > 0) {
            for (var i = 0; i < res.stores.length; i++) {
              this.selectedStores.push(res.stores[i].store_id);
            }
            if (this.selectedStores.length == this.stores.length) {
              this.isAll = true;
            }
          } else {
            this.selectedStores = [];
            this.isAll = false;
          }

          this.setAvailableStr();
        });
    },
    save() {
      if (this.selectedStores.length > 0) {
        this.tax.stores = this.selectedStores;
      } else {
        this.tax.stores = [];
      }

      this.$api
        .postAPI({
          _action: "/tax/",
          _body: this.tax,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          router.push("/settings");
        })
        .catch(e => {});
    },

    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.isAll = false;
      this.tax.id = this.$route.params.id;
    } else {
      this.isAll = true;
    }
    this.getStores();
  }
};
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <div class="card rounded-5 p-3 border">
            <div class="card-body form-style">
              <div class="row">
                <div class="col-lg-9 mb-4">
                  <label for>{{$lang.messages.name}}</label><span style="color:#ff0000"> *</span>
                  <input
                    name="name"
                    v-model="tax.name"
                    v-validate="'required|max:300'"
                    class="form-control" maxlength="300"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>

                <div class="col-lg-3 mb-4">
                  <label for>{{$lang.messages.rate}} %</label><span style="color:#ff0000"> *</span>
                  <input min="0" max="100"
                    name="rate"
                    v-model="tax.rate"
                    v-validate="'required|decimal|max_value:100|min_value:0'"
                    class="form-control"
                    :class="{'input': true, 'is-danger': errors.has('rate') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.rate"
                  />
                  <i v-show="errors.has('rate')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('rate')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_tax_rate}}</span>
                </div>

                <div class="col-lg-12">
                  <div class="form-group">
                    <label for>{{$lang.messages.type}}</label><span style="color:#ff0000"> *</span>
                    <div class="custom-select-dd">
                      <select
                        class="form-control"
                        v-model="tax.type"
                        v-validate="'required'"
                        name="type"
                      >
                        <option value>{{$lang.messages.select}}</option>
                        <option value="INCLUDED">{{$lang.messages.included_in_the_price}}</option>
                        <option value="ADDED">{{$lang.messages.added_in_to_the_price}}</option>
                      </select>
                      <i v-show="errors.has('type')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('type')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_type}}</span>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 mb-3">
                  <div class="form-group">
                    <label for>{{$lang.messages.option}}</label><span style="color:#ff0000"> *</span>
                    <div class="custom-select-dd">
                      <select
                        class="form-control"
                        v-model="tax.option"
                        v-validate="'required'"
                        name="option"
                      >
                        <option value>{{$lang.messages.select}}</option>
                        <option value="NEW_TEM">{{$lang.messages.apply_the_tax_to_the_new_item}}</option>
                        <option
                          value="EXISTING_ITEM"
                        >{{$lang.messages.apply_the_tax_to_the_existing_item}}</option>
                        <option
                          value="BOTH"
                        >{{$lang.messages.apply_the_tax_to_all_new_and_existing_item}}</option>
                        <option value="NONE">{{$lang.messages.none}}</option>
                      </select>

                      <i v-show="errors.has('option')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('option')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_option}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6">
          <div class="card rounded-5 pt-1 border">
            <div
              class="card-header bg-white border-bottom cursor-pointer py-3 px-lg-5 px-4"
              data-toggle="collapse"
              data-target=".stores-list"
              aria-expanded="false"
              aria-controls="multiCollapseExample1 multiCollapseExample2"
            >
              <h4 class="font-20 d-inline">
                {{$lang.messages.store}}
                <span
                  class="font-16 text-secondary ml-3 d-inline"
                >{{availableStoreStr}}</span>
              </h4>
              <img src="/images/down-arrow.svg" width="15" class="d-inline float-right mt-1" />
            </div>
            <div class="card-body form-style collapse stores-list px-lg-5 px-4 py-lg-5 py-4">
              <div class="custom-control custom-checkbox mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="checkbox-1"
                  v-model="isAll"
                  @change="checkAllStores($event)"
                />
                <label
                  class="custom-control-label text-dark ml-2"
                  for="checkbox-1"
                >{{$lang.messages.available_in_all_stores}}</label>
              </div>
              <div>
                <div
                  class="custom-control custom-checkbox mb-3 ml-3"
                  v-for="store in stores"
                  :key="store.id"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :value="store.id"
                    :id="'type_'  +store.id"
                    v-model="selectedStores"
                    @change="checkUncheckStore($event)"
                  />

                  <label
                    class="custom-control-label text-dark ml-2"
                    :for="'type_' +store.id"
                  >{{store.name}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 text-lg-right text-center">
          <button
            type="button"
            class="btn btn-primary mr-3"
            @click="validateForm()"
            id="save-btn"
          >{{$lang.messages.save_btn_text}}</button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="$router.go(-1)"
          >{{$lang.messages.cancel_btn_text}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
